export default __webpack_public_path__ + "static/blob11-23cfd8d3c840f58752cfdbb21ed2a8da.svg";